import React from "react";
import { CheckCircle2, XCircle, Copy } from "lucide-react";
import Tooltip from "../atoms/Tooltip";

interface QuickActionButtonsProps {
  onApprove?: () => void;
  onReject?: () => void;
  onDuplicate?: () => void;
  disabled?: boolean;
  loading?: boolean;
}

const QuickActionButtons: React.FC<QuickActionButtonsProps> = ({
  onApprove,
  onReject,
  onDuplicate,
  disabled,
  loading,
}) => {
  return (
    <div className="flex gap-1 flex-nowrap">
      {onApprove && (
        <Tooltip content={disabled ? 'Pending implementation' : 'Approve'}>
          <button
            type="button"
            className="p-1 text-ds-status-success-main hover:bg-ds-status-success-light rounded disabled:opacity-50 flex-shrink-0 min-w-[28px] min-h-[28px] flex items-center justify-center transition-colors"
            onClick={onApprove}
            disabled={disabled || loading}
            title="Approve"
          >
            {loading ? (
              <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-ds-status-success-main" />
            ) : (
              <CheckCircle2 size={16} />
            )}
          </button>
        </Tooltip>
      )}
      {onReject && (
        <Tooltip content={disabled ? 'Pending implementation' : 'Reject'}>
          <button
            type="button"
            className="p-1 text-ds-status-error-main hover:bg-ds-status-error-light rounded disabled:opacity-50 flex-shrink-0 min-w-[28px] min-h-[28px] flex items-center justify-center transition-colors"
            onClick={onReject}
            disabled={disabled || loading}
            title="Reject"
          >
            {loading ? (
              <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-ds-status-error-main" />
            ) : (
              <XCircle size={16} />
            )}
          </button>
        </Tooltip>
      )}
      {onDuplicate && (
        <Tooltip content="Duplicate">
          <button
            type="button"
            className="p-1 text-ds-primary-600 hover:bg-bg-hover rounded disabled:opacity-50 flex-shrink-0 min-w-[28px] min-h-[28px] flex items-center justify-center transition-colors"
            onClick={onDuplicate}
            disabled={disabled || loading}
            title="Duplicate"
          >
            <Copy size={16} />
          </button>
        </Tooltip>
      )}
    </div>
  );
};

export default QuickActionButtons;
